<!--
 * @Description: 已领取过券
 * @Author: xd
 * @Date: 2021-11-25 16:34:01
-->
<template>
  <Modal
    class="modal-ReceivedCoupon"
    :name="modalName"
    :show-close="true"
    :cover-closeable="false"
    :close-btn-handler="handleClose"
    @modalClose="handleClose"
  >
    <div
      slot="modal-content"
      class="content"
    >
      <div class="jumpGasUrlBtn" @click="jumpGasUrl"></div>
    </div>
  </Modal>
</template>

<script>
import Modal from '../Modal.vue';

export default {
  name: 'ReceivedCoupon',
  components: {
    Modal
  },

  data() {
    return {
      modalName: 'ReceivedCouponShow',
    };
  },
  methods: {
    /**
     * 关闭按钮处理
     */
    handleClose() {
      this.$emit('modalHandler', 'modalClose', this.modalName);
    },
    // 领取按钮点击
    jumpGasUrl() {
      this.$emit('jumpGasUrl');
    },
  }
};
</script>

<style lang="scss">
@import "../../css/common-mixin";

.modal-ReceivedCoupon {
  .modal{
    width: rpx(610);
    height: rpx(587);
    top:40%;
    .close{
      top: rpx(650);
      left: 50%;
      transform: translateX(-50%);
    }
  }
  .content {
    width: rpx(610);
    height: rpx(587);
    background: url("../../../assets/endPage/get-coupon-fail.png") center no-repeat;
    background-size: 100% 100%;
    padding-top: rpx(110);
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    position: relative;
    .jumpGasUrlBtn{
      width: rpx(440);
      height: rpx(85);
      position: absolute;
      bottom: rpx(47);
      left: 50%;
      transform: translateX(-50%);
    }
  }
}
</style>
